import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { TTactinEventBus } from '../../model/events/EventBus';
import { LoginEvent } from '../../model/events/TactinEvents';
import { ConnectionError, ExecutionError, Failed } from '../../utils/api/TactinApi';
import { PreLoginUserApi } from '../../utils/api/UserApi';
import { Loader } from '../basic/Loader';
import './LoginWindow.css';

type LoginWindowProps = {
    asAdmin: boolean;
    eventBus: TTactinEventBus;
}

export default function LoginWindow(props: LoginWindowProps) {
    const [errorMsg, setError] = useState('');
    const [user, setUser] = useState('');
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const userInputRef = useRef<HTMLInputElement>(null);
    const passwordInputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        const savedUser = localStorage.getItem('savedLogin');
        if (savedUser) {
            setUser(savedUser);
            passwordInputRef.current?.focus();
        } else {
            userInputRef.current?.focus();
        }
    }, []);

    const doLogin = () => {
        if (user) {
            setIsLoading(true);
            PreLoginUserApi.login(user, password || '', props.asAdmin)
                .then(v => {
                    localStorage.setItem('savedLogin', user);
                    props.eventBus.notify(new LoginEvent(v));
                })
                .catch(err => {
                    if (err instanceof Failed) setError(err.message);
                    else if (err instanceof ExecutionError) setError('Execution error!');
                    else if (err instanceof ConnectionError) setError('Connection error!');
                })
                .finally(() => setIsLoading(false));
        }
    };

    const errorCleanup = () => {
        setError('');
        setPassword('');
    };

    useEffect(() => {
        const handleEnterKey = (event: KeyboardEvent) => {
            if (event.key === 'Enter') {
                errorCleanup();
            }
        };

        if (errorMsg) {
            window.addEventListener('keydown', handleEnterKey);
        } else {
            window.removeEventListener('keydown', handleEnterKey);
        }

        return () => window.removeEventListener('keydown', handleEnterKey);
    }, [errorMsg]);

    return (
        <>
            {!errorMsg ? (
                <div className='login-window' onKeyDown={e => e.key === 'Enter' && doLogin()}>
                    <input 
                        ref={userInputRef} 
                        className='login-name' 
                        type='text' 
                        placeholder='Użytkownik' 
                        value={user} 
                        onChange={e => setUser(e.target.value)} 
                        disabled={isLoading}
                    />
                    <input 
                        ref={passwordInputRef}
                        className='login-password' 
                        type='password' 
                        placeholder='Hasło' 
                        value={password} 
                        onChange={e => setPassword(e.target.value)} 
                        disabled={isLoading}
                    />
                    {isLoading ? (
                        <Loader />
                    ) : (
                        <button className='login-button' onClick={doLogin}>ZALOGUJ</button>
                    )}
                </div>
            ) : (
                <div className='login-window'>
                    <div className='err-message'>{errorMsg || '.'}</div>
                    <button className='login-button' onClick={errorCleanup}>OK</button>
                </div>
            )}
        </>
    );
}

